/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Ha Van Truong (Vincent) (hvtruong3@rsupartners.com)
 *
 * @description
 *
 * @created at Web Jan 08 2025
 **/

import React, { useCallback, useEffect, useState } from "react";

import { SearchBar } from "@/frameworks/core/components";
import { Column, Row } from "@/frameworks/designStuff/components";
import { EventHandler } from "@rfice/eventhandler";
import { EventID } from "@/frameworks/core/commons";
import { _T } from "@rfice/language";

export default function MessageSearchInConversation({
	onClear,
	roomId,
	searchedText
}: {
	onClear: () => void;
	roomId: string;
	searchedText: string;
}) {
	const [searchValue, setSearchValue] = useState("");

	const onSubmit = useCallback(
		(value: string) => {
			EventHandler.emit(EventID.OPEN_SEARCH_RESULT_ON_MINI_CHAT, {
				searchValue: value,
				isOpenSearchResult: true,
				roomId
			});
		},
		[roomId]
	);

	const handleSubmit = useCallback(
		(ev: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLParagraphElement>) => {
			ev.preventDefault();
			if (!searchValue || searchValue.trim().length === 0) return;
			onSubmit(searchValue);
		},
		[searchValue]
	);

	useEffect(() => {
		setSearchValue(searchedText);
	}, [searchedText]);

	return (
		<Row style={{ width: "100%" }}>
			<Column.form onSubmit={handleSubmit} css={{ width: "100%" }}>
				<SearchBar
					style={{ height: "32px" }}
					autoFocus={true}
					value={searchValue}
					onClear={() => {
						setSearchValue("");
						onClear?.();
					}}
					onChange={(ev) => setSearchValue(ev.target.value)}
					placeholder={_T("대화내용 검색")}
				/>
			</Column.form>
		</Row>
	);
}
